// extracted by mini-css-extract-plugin
module.exports = {"container":"DiscountBadge_container__RCOU6"};